import { isValidPhoneNumber } from 'react-phone-number-input';
import { TDR } from 'tdr-common';
import { z } from 'zod';
import { t } from 'i18next';

const NAME_REGEX = new RegExp(/^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,]{1,20}$/);

export const GuestInfoSchema = z.object({
	firstName: z
		.string({ required_error: t('errors.first_name_required') })
		.min(2, t('errors.first_name_min_length'))
		.max(20, t('errors.first_name_max_length'))
		.refine(
			(value) => {
				// Using the following syntax to avoid issues with names not using english alphabet, (e.g. Chinese, Japanese, Eastern EU etc.)
				return NAME_REGEX.test(value);
			},
			{ message: t('errors.name_special_characters') }
		),

	lastName: z
		.string({ required_error: t('errors.last_name_required') })
		.min(2, t('errors.last_name_min_length'))
		.max(20, t('errors.last_name_max_length'))
		.refine(
			(value) => {
				// Using the following syntax to avoid issues with names not using english alphabet, (e.g. Chinese, Japanese, Eastern EU etc.)
				return NAME_REGEX.test(value);
			},
			{ message: t('errors.name_special_characters') }
		),
	email: z.string({ required_error: t('errors.email_required') }).email(t('errors.invalid_email')),
	phone: z.string({ required_error: t('errors.phone_required') }).refine((val) => isValidPhoneNumber(val), {
		message: t('errors.invalid_phone_number')
	}),
	occasion: z.nativeEnum(TDR.Occasion).optional(),
	specialRequests: z.string().max(300, t('errors.special_requests_max_length')),
	fastCheckoutEnabled: z.boolean().optional(),
	companyName: z.string().max(300, t('errors.company_name_max_length')).optional(),
	eventDuration: z.string().max(300, t('errors.event_duration_max_length')).optional(),
	estimatedBudget: z.string().max(300, t('errors.estimated_budget_max_length')).optional(),
	emailMarketingConsentGranted: z.boolean().optional(),
	smsMarketingConsentGranted: z.boolean().optional(),
	smsTransactionalConsentGranted: z.boolean().optional()
});

export type GuestInfo = z.infer<typeof GuestInfoSchema>;

export const PaymentInfoSchema = z.object({
	promoCode: z.string().optional()
});

export type PaymentInfo = z.infer<typeof PaymentInfoSchema>;

export type GuestDetailsDTO =
	| TDR.CheckoutSession.ConfirmFreeCheckoutSessionInput
	| TDR.CheckoutSession.UpdateCheckoutSessionInput;

export enum SubmissionError {
	Confirmation = 'Confirmation',
	Proceed = 'Proceed',
}
